export default __webpack_public_path__ + "static/media/check.26221b45.svg";